import { MobileVerificationResult } from './mobileverificationresult';
import { DIAppExpiry } from './diappexpiry';
import { ProfileStrengthInfo } from './profilestrengthinfo';

export class UserJobHistoryUpdateResponse {

    public sessionValid!: boolean;
    public errorCode!: string;
    public errorMessage!: string;
    public errorMessageData!: number;
    public verificationResult: MobileVerificationResult = new MobileVerificationResult();
    public appExpiry: DIAppExpiry = new DIAppExpiry();
    public profileStrengthInfo: ProfileStrengthInfo = new ProfileStrengthInfo();
    public meta = { 
    };

}
